/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import './assetDetailsCard.css';
import AssetCardMoreMobile from './AssetCardMoreMobile';
import EmptyCardMoreMobile from './EmptyCardMoreMobile';

const AssetDetailCardMobile = (props) => {
    const {
        closeButton,
        markerValue,
        timeStampDisplay,
        assetSelection,
        lastSeenTimestamp,
        emptyCardValue,
        open,
        drawerRef,
    } = props;

    // console.log('timestampDisplaaaayyyyy', timeStampDisplay);

    const getLatestDataButton = (e) => {
        e.preventDefault();
        // console.log('refreshButton');
    };

    return (
        <>
        {
            Object.keys(markerValue || {}).length > 0 ? <AssetCardMoreMobile drawerRef={drawerRef} open={open} markerValue={markerValue} assetSelection={assetSelection} timeStampDisplay={timeStampDisplay} closeButton={closeButton} getLatestDataButton={getLatestDataButton} lastSeenTimestamp={lastSeenTimestamp} /> : <EmptyCardMoreMobile drawerRef={drawerRef} open={open} assetSelection={assetSelection} closeButton={closeButton} emptyCardValue={emptyCardValue} />
        }
        </>
  );
};

export default AssetDetailCardMobile;
